import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=3e6e467c&"
import script from "./Policy.vue?vue&type=script&lang=js&"
export * from "./Policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports